import React from 'react';
import { Clock, Users, GraduationCap } from 'lucide-react';

const META_ICONS = [
  { key: 'duration', label: 'Duration', Icon: Clock },
  { key: 'seats', label: 'Seats', Icon: Users },
  { key: 'level', label: 'Level', Icon: GraduationCap },
];

export default function CourseMeta({ course }) {
  return (
    <div className="mt-6 grid grid-cols-3 gap-3">
      {META_ICONS.map(({ key, label, Icon }) => (
        <div key={key} className="rounded-2xl bg-[var(--pca-blue-tint)] p-4">
          <Icon size={16} className="text-[var(--pca-blue)]" />
          <div className="text-[11px] uppercase tracking-wider text-slate-500 mt-2">{label}</div>
          <div className="font-bold text-[#0B2E6E]">{course[key]}</div>
        </div>
      ))}
    </div>
  );
}
